(() => {
  const shopRoot = window.Shopify?.routes?.root || '/';
  const money = (root, cents) => {
    const value = (cents / 100).toFixed(2);
    return (root.dataset.moneyFormat || 'CHF {{amount}}').replace(/\{\{\s*amount(?:_with_comma_separator)?\s*\}\}/, value);
  };

  document.querySelectorAll('[data-guided-commerce]').forEach(root => {
    if (root.dataset.bound || root.dataset.flow === 'gift-finder') return;
    root.dataset.bound = 'true';
    const flow = root.dataset.flow;
    const workspace = root.querySelector('[data-guided-workspace]');
    const panels = [...root.querySelectorAll('[data-panel]')];
    const indicators = [...root.querySelectorAll('[data-indicator]')];
    const error = root.querySelector('[data-error]');
    const next = root.querySelector('[data-next]');
    const back = root.querySelector('[data-back]');
    const add = root.querySelector('[data-add]');
    const summary = root.querySelector('[data-summary]');
    const announcement = root.querySelector('[data-guided-announcement]');
    const noSafeMatch = root.querySelector('[data-no-safe-match]');
    const giftBoxBlocked = root.dataset.giftBoxBlocked === 'true';
    const state = { version: 6, step: 0, answers: {}, quantities: {}, variants: {}, message: '', ribbon: '', category: 'seifen', occasion: '', edition: '', sourceRecipient: '', sourcePicker: '', sourceScent: '', sourceGiftTheme: '', sourceGiftThemeLabel: '', requestMarker: '', requestSignature: '', requestAttempted: false, requestBlocked: false };
    const transactionKey = `${root.dataset.storageKey}:pending-cart-add`;
    let pendingTransaction = null;

    root.classList.add('is-started');
    if (workspace) workspace.hidden = false;

    const products = [...root.querySelectorAll('[data-product]')];
    const componentCatalog = root.querySelector('[data-component-catalog]');
    const componentProducts = componentCatalog ? [...componentCatalog.querySelectorAll('[data-product]')] : [];
    const allowedIds = product => new Set(String(product?.dataset.allowedVariants || '').split(',').map(id => id.trim()).filter(id => /^[1-9][0-9]*$/.test(id)));
    const safeProduct = product => {
      const id = String(product?.dataset.variant || '');
      return Boolean(product && product.dataset.available === 'true' && /^[1-9][0-9]*$/.test(id) && allowedIds(product).has(id));
    };
    const productByBlock = id => products.find(product => product.dataset.block === id && safeProduct(product));
    const finderUnavailable = () => flow === 'gift-finder' && !products.some(safeProduct);

    const used = () => componentProducts.reduce((sum, product) => sum + Number(state.quantities[product.dataset.block] || 0), 0);
    const capacity = () => Number(productByBlock(state.answers.box)?.dataset.capacity || 0);
    const ribbonValid = () => root.dataset.ribbonRequired !== 'true' || [...root.querySelectorAll('[name="ribbon"]')].some(input => input.value === state.ribbon);

    let recovered = false;
    let stale = false;
    try {
      const saved = JSON.parse(localStorage.getItem(root.dataset.storageKey));
      if (saved && saved.flow === flow && saved.state && Number(saved.state.version) === 6) {
        Object.assign(state, saved.state);
        recovered = true;
      } else if (saved) stale = true;
    } catch (_) {}
    try {
      const pending = JSON.parse(localStorage.getItem(transactionKey));
      const validItems = Array.isArray(pending?.items) && pending.items.length && pending.items.every(item =>
        /^[1-9][0-9]*$/.test(String(item?.id)) &&
        Number.isSafeInteger(Number(item?.quantity)) &&
        Number(item.quantity) > 0 &&
        item?.properties?.['_Guided request'] === pending.marker
      );
      if (pending?.flow === flow && typeof pending.marker === 'string' && pending.marker && validItems) pendingTransaction = pending;
    } catch (_) {}

    const hashContext = { occasion: '', edition: '', sourceRecipient: '', sourcePicker: '', sourceScent: '', entryHub: false };
    let hashApplied = false;
    let invalidFinderPrefill = false;
    let freshHubEntry = false;
    try {
      if (window.location.hash) {
        const hashParams = new URLSearchParams(window.location.hash.slice(1));
        if (flow === 'gift-finder' || flow === 'gift-box') {
          const validOccasions = ['birthday', 'thanks', 'wedding', 'new_home', 'christmas', 'just_because'];
          const validEditions = ['seasonal'];
          const validRecipients = ['partner', 'family', 'friend', 'team', 'self'];
          const validPickers = ['self', 'habibe'];
          const validScents = ['floral', 'herbal', 'citrus', 'lavender', 'warm', 'surprise'];
          const occasion = hashParams.get('occasion');
          const edition = hashParams.get('edition');
          const recipient = hashParams.get('recipient');
          const picker = hashParams.get('picker');
          const scent = hashParams.get('scent');
          if (validOccasions.includes(occasion)) hashContext.occasion = occasion;
          if (validEditions.includes(edition)) hashContext.edition = edition;
          if (flow === 'gift-box' && validRecipients.includes(recipient)) hashContext.sourceRecipient = recipient;
          if (flow === 'gift-box' && validPickers.includes(picker)) hashContext.sourcePicker = picker;
          if (flow === 'gift-box' && validScents.includes(scent)) hashContext.sourceScent = scent;
          hashContext.entryHub = flow === 'gift-finder' && hashParams.get('entry') === 'hub';
          freshHubEntry = hashContext.entryHub;
          if (freshHubEntry) {
            state.step = 0;
            state.answers = {};
            state.quantities = {};
            state.variants = {};
            state.message = '';
            state.requestMarker = '';
            state.requestSignature = '';
            state.requestAttempted = false;
            state.requestBlocked = false;
            state.occasion = '';
            state.edition = '';
            state.sourceRecipient = '';
            state.sourcePicker = '';
            state.sourceScent = '';
            recovered = false;
            hashParams.delete('entry');
            const cleanHash = hashParams.toString();
            window.history?.replaceState?.(window.history.state, '', `${window.location.pathname || ''}${window.location.search || ''}${cleanHash ? `#${cleanHash}` : ''}`);
          }
          Object.entries(hashContext).forEach(([name, value]) => {
            if (name === 'entryHub' || !value) return;
            state[name] = value;
            hashApplied = true;
          });
          if (flow === 'gift-box' && hashParams.get('gift_finder') === '1' && hashParams.getAll('prefill').length === 1) {
            const chosen = productByBlock(hashParams.get('prefill'));
            const variant = hashParams.get('variant');
            const themeId = hashParams.get('gift_theme');
            if (chosen && variant === chosen.dataset.variant && /^[a-z][a-z0-9_-]{1,63}$/i.test(themeId || '')) {
              // A fresh finder entry overrides a previously saved builder selection only
              // when the chosen component and exact approved Shopify variant still match.
              state.step = 0;
              state.answers = {};
              state.quantities = { [chosen.dataset.block]: 1 };
              state.variants = { [chosen.dataset.block]: variant };
              state.message = '';
              state.ribbon = '';
              state.category = 'seifen';
              state.sourceGiftTheme = themeId;
              state.sourceGiftThemeLabel = String(hashParams.get('gift_theme_label') || themeId).slice(0, 80);
              state.sourceRecipient = hashContext.sourceRecipient;
              hashApplied = true;
              recovered = false;
              hashParams.delete('gift_finder');
              hashParams.delete('prefill');
              hashParams.delete('variant');
              hashParams.delete('recipient');
              hashParams.delete('gift_theme');
              hashParams.delete('gift_theme_label');
              const remaining = hashParams.toString();
              window.history?.replaceState?.(window.history.state, '', `${window.location.pathname || ''}${window.location.search || ''}${remaining ? `#${remaining}` : ''}`);
            } else {
              // Do not show an unrelated saved box when this exact soap is gone.
              state.step = 0;
              state.answers = {};
              state.quantities = {};
              state.variants = {};
              state.message = '';
              state.ribbon = '';
              state.sourceRecipient = '';
              state.sourceGiftTheme = '';
              state.sourceGiftThemeLabel = '';
              recovered = false;
              invalidFinderPrefill = true;
              window.history?.replaceState?.(window.history.state, '', `${window.location.pathname || ''}${window.location.search || ''}`);
            }
          } else if (flow === 'gift-box' && hashParams.getAll('prefill').length && !recovered) {
            state.quantities = state.quantities || {};
            const prefills = hashParams.getAll('prefill');
            prefills.forEach(pid => {
                if (productByBlock(pid)) {
                    state.quantities[pid] = (state.quantities[pid] || 0) + 1;
                }
            });
            hashApplied = true;
          }
        }
      }
    } catch (_) {}

    if (!state.answers || typeof state.answers !== 'object' || Array.isArray(state.answers)) state.answers = {};
    if (!state.quantities || typeof state.quantities !== 'object' || Array.isArray(state.quantities)) state.quantities = {};
    if (!state.variants || typeof state.variants !== 'object' || Array.isArray(state.variants)) state.variants = {};
    state.message = typeof state.message === 'string' ? state.message.slice(0, 140) : '';
    state.ribbon = typeof state.ribbon === 'string' ? state.ribbon : '';
    state.category = ['seifen', 'pflege', 'extras'].includes(state.category) ? state.category : 'seifen';
    state.requestMarker = typeof state.requestMarker === 'string' ? state.requestMarker : '';
    state.requestSignature = typeof state.requestSignature === 'string' ? state.requestSignature : '';
    state.requestAttempted = state.requestAttempted === true;
    state.requestBlocked = state.requestBlocked === true;
    state.searchQuery = '';

    if (hashApplied && state.edition === 'seasonal' && !recovered) {
      const month = new Date().getMonth();
      const seasonIndex = (month === 11 || month <= 1) ? 3 : (month >= 2 && month <= 4) ? 0 : (month >= 5 && month <= 7) ? 1 : 2;
      const ribbons = [...root.querySelectorAll('[name="ribbon"]')];
      if (ribbons[seasonIndex]) state.ribbon = ribbons[seasonIndex].value;
    }

    state.occasion = typeof state.occasion === 'string' && ['birthday','thanks','wedding','new_home','christmas','just_because'].includes(state.occasion) ? state.occasion : '';
    state.edition = state.edition === 'seasonal' ? state.edition : '';
    state.sourceRecipient = typeof state.sourceRecipient === 'string' && ['partner','family','friend','team','self'].includes(state.sourceRecipient) ? state.sourceRecipient : '';
    state.sourcePicker = typeof state.sourcePicker === 'string' && ['self','habibe'].includes(state.sourcePicker) ? state.sourcePicker : '';
    state.sourceScent = typeof state.sourceScent === 'string' && ['floral','herbal','citrus','lavender','warm','surprise'].includes(state.sourceScent) ? state.sourceScent : '';
    state.sourceGiftTheme = typeof state.sourceGiftTheme === 'string' && /^[a-z][a-z0-9_-]{1,63}$/i.test(state.sourceGiftTheme) ? state.sourceGiftTheme : '';
    state.sourceGiftThemeLabel = state.sourceGiftTheme && typeof state.sourceGiftThemeLabel === 'string' ? state.sourceGiftThemeLabel.slice(0, 80) : '';
    state.step = Number.isInteger(Number(state.step)) ? Math.max(0, Number(state.step)) : 0;

    const permittedAnswerNames = new Set(flow === 'gift-finder' ? ['recipient', 'scent', 'product'] : flow === 'gift-box' ? ['box'] : []);
    Object.entries(state.answers).forEach(([name, value]) => {
      if (!permittedAnswerNames.has(name) || typeof value !== 'string') {
        delete state.answers[name];
        return;
      }
      if (!['product', 'box'].includes(name) && !root.querySelector(`[data-answer="${name}"][data-value="${CSS.escape(value)}"]`)) delete state.answers[name];
    });
    Object.entries(state.quantities).forEach(([id, count]) => {
      const quantity = Number(count);
      if (!Number.isSafeInteger(quantity) || quantity < 0) delete state.quantities[id];
      else state.quantities[id] = quantity;
    });
    if (state.answers.product && !productByBlock(state.answers.product)) delete state.answers.product;
    if (state.answers.box && !productByBlock(state.answers.box)) delete state.answers.box;
    products.forEach(product => {
      const selected = state.answers.product === product.dataset.block || state.answers.box === product.dataset.block || Number(state.quantities[product.dataset.block] || 0) > 0;
      if (!selected || !recovered) return;
      const savedId = String(state.variants[product.dataset.block] || '');
      const select = product.querySelector('[data-variant-select]');
      const validSavedOption = select
        ? [...select.options].find(option => option.value === savedId && option.dataset.available === 'true' && allowedIds(product).has(option.value))
        : savedId === String(product.dataset.variant) && safeProduct(product);
      if (validSavedOption) return;
      delete state.variants[product.dataset.block];
      delete state.quantities[product.dataset.block];
      if (state.answers.product === product.dataset.block) delete state.answers.product;
      if (state.answers.box === product.dataset.block) delete state.answers.box;
      stale = true;
    });
    Object.keys(state.quantities).forEach(id => {
      const product = componentProducts.find(candidate => candidate.dataset.block === id && safeProduct(candidate));
      if (!product) delete state.quantities[id];
      else state.quantities[id] = Math.min(state.quantities[id], Number(product.dataset.max || 2));
    });
    const clampQuantitiesToCapacity = () => {
      let remaining = capacity();
      componentProducts.forEach(product => {
        const id = product.dataset.block;
        if (!Object.prototype.hasOwnProperty.call(state.quantities, id)) return;
        state.quantities[id] = Math.max(0, Math.min(Number(state.quantities[id]), remaining));
        remaining -= state.quantities[id];
        if (state.quantities[id] === 0) delete state.quantities[id];
      });
    };
    if (flow === 'gift-box' && state.answers.box) clampQuantitiesToCapacity();

    let maxValid = 0;
    if (flow === 'gift-finder') {
      if (state.answers.recipient) maxValid = 1;
      if (maxValid === 1 && state.answers.scent) maxValid = 2;
    } else if (flow === 'gift-box') {
      if (state.answers.box) maxValid = 1;
      if (maxValid === 1 && used() === capacity() && capacity() > 0) maxValid = 2;
      if (maxValid === 2 && ribbonValid() && state.message.length <= 140) maxValid = 3;
    }
    state.step = Math.min(state.step, maxValid);

    const persist = () => {
      try { localStorage.setItem(root.dataset.storageKey, JSON.stringify({ flow, state })); } catch (_) {}
    };
    const invalidateRequest = () => {
      state.requestMarker = '';
      state.requestSignature = '';
      state.requestAttempted = false;
      state.requestBlocked = false;
    };
    const answerLabel = (name, value) => root.querySelector(`[data-answer="${name}"][data-value="${CSS.escape(value)}"] strong`)?.textContent.trim() || value;
    const giftBoxComplete = () => !giftBoxBlocked && Boolean(state.answers.box) && capacity() > 0 && used() === capacity() && ribbonValid() && state.message.length <= 140;

    const valid = () => {
      if (finderUnavailable()) return false;
      if (flow === 'gift-finder') return state.step < 2 ? Boolean(state.answers[['recipient', 'scent'][state.step]]) : Boolean(state.answers.product);
      if (flow === 'gift-box') {
        if (giftBoxBlocked) return false;
        if (state.step === 0) return Boolean(state.answers.box);
        if (state.step === 1) return used() === capacity() && capacity() > 0;
        if (state.step === 2) return ribbonValid() && state.message.length <= 140;
        return giftBoxComplete();
      }
      return state.step < 4 ? Boolean(state.answers[['feel', 'zone', 'scent', 'needs'][state.step]]) : Boolean(state.answers.product);
    };

    const formatPanelAnnouncement = () => {
      const heading = panels[state.step]?.querySelector('h2')?.textContent.trim() || '';
      if (!heading) return '';
      if (flow === 'gift-finder' && state.step === 2) return `${root.dataset.resultLabel || panels[2]?.dataset.resultLabel}: ${heading}`;
      const questionCount = flow === 'gift-finder' ? 3 : panels.length;
      return `${root.dataset.stepLabel} ${state.step + 1} ${root.dataset.ofLabel} ${questionCount}: ${heading}`;
    };
    const render = () => {
      if (flow === 'gift-box' && state.answers.box) {
         const cap = capacity();
         let currentUsed = used();
         if (currentUsed > cap) {
            for (const id in state.quantities) {
               while (state.quantities[id] > 0 && currentUsed > cap) {
                  state.quantities[id]--;
                  currentUsed--;
               }
               if (state.quantities[id] === 0) delete state.quantities[id];
            }
         }
      }
      if (finderUnavailable()) state.step = panels.length - 1;
      root.dataset.step = String(state.step);
      products.forEach(product => {
        const select = product.querySelector('[data-variant-select]');
        const savedId = state.variants[product.dataset.block];
        const savedOption = select ? [...select.options].find(option => option.value === savedId && option.dataset.available === 'true' && allowedIds(product).has(option.value)) : null;
        if (savedOption) {
          select.value = savedOption.value;
          product.dataset.variant = savedOption.value;
          product.dataset.variantTitle = savedOption.dataset.title || '';
          product.dataset.price = savedOption.dataset.price;
          product.dataset.priceLabel = savedOption.dataset.priceLabel;
          product.dataset.available = savedOption.dataset.available;
          product.querySelector('[data-variant-input]').value = savedOption.value;
          product.querySelector('[data-product-price]').textContent = savedOption.dataset.priceLabel;
        } else if (savedId) delete state.variants[product.dataset.block];
      });
      panels.forEach((panel, i) => panel.hidden = i !== state.step);
      indicators.forEach((item, i) => {
        item.classList.toggle('is-active', i === state.step);
        item.classList.toggle('is-complete', i < state.step);
        if (i === state.step) item.setAttribute('aria-current', 'step'); else item.removeAttribute('aria-current');
      });
      root.querySelectorAll('[data-answer]').forEach(button => {
        const active = state.answers[button.dataset.answer] === button.dataset.value;
        button.classList.toggle('is-selected', active);
        if (button.getAttribute('role') === 'radio') {
          button.setAttribute('aria-checked', String(active));
          button.tabIndex = active || !button.parentElement.querySelector('[role="radio"][aria-checked="true"]') && button === button.parentElement.querySelector('[role="radio"]') ? 0 : -1;
        } else button.setAttribute('aria-pressed', String(active));
      });
      const founder = root.querySelector('[data-founder]');
      if (founder) founder.hidden = state.answers.picker !== 'habibe';
      products.forEach(product => {
        const name = product.dataset.answerName;
        const active = name && state.answers[name] === product.dataset.block;
        product.classList.toggle('is-selected', active);
        const selectProduct = product.querySelector('[data-select-product]');
        const group = selectProduct?.closest('[role="radiogroup"]');
        if (((flow === 'gift-finder' && name === 'product') || (flow === 'gift-box' && name === 'box')) && selectProduct && group) {
          selectProduct.setAttribute('role', 'radio');
          selectProduct.setAttribute('aria-checked', String(active));
          selectProduct.tabIndex = active || !group?.querySelector('[role="radio"][aria-checked="true"]') && selectProduct === group?.querySelector('[role="radio"]:not([disabled])') ? 0 : -1;
        } else if (selectProduct) {
          selectProduct.removeAttribute('role');
          selectProduct.removeAttribute('aria-checked');
          selectProduct.removeAttribute('tabindex');
          selectProduct.setAttribute('aria-pressed', String(active));
        }
        const qty = Number(state.quantities[product.dataset.block] || 0);
        product.classList.toggle('has-quantity', qty > 0);
        if ((active || qty > 0) && safeProduct(product)) state.variants[product.dataset.block] = String(product.dataset.variant);
        if (product.querySelector('[data-qty]')) product.querySelector('[data-qty]').textContent = qty;
        const plus = product.querySelector('[data-qty-plus]');
        if (plus) plus.disabled = used() >= capacity() || qty >= Number(product.dataset.max || 2) || !safeProduct(product);
        if (flow === 'gift-box' && product.dataset.category) {
          const matchCategory = state.category === 'all' || product.dataset.category === state.category;
          const searchQ = (state.searchQuery || '').toLowerCase().trim();
          const matchSearch = !searchQ || (product.dataset.title || '').toLowerCase().includes(searchQ);
          const isSelected = Number(state.quantities[product.dataset.block] || 0) > 0;
          product.hidden = state.step === 1 && (!isSelected && (!matchCategory || !matchSearch));
        }
      });
      root.querySelectorAll('[data-catalog-tab]').forEach(tab => {
        const active = tab.dataset.catalogTab === state.category;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      if (flow === 'skin' && state.step === 4) {
        const requiredConstraint = state.answers.needs;
        const matchProduct = product => {
          const zones = (product.dataset.zones || '').split(',').filter(Boolean);
          const scents = (product.dataset.scents || '').split(',').filter(Boolean);
          if (!product.dataset.profile || !zones.length || !scents.length) return false;
          if (product.dataset.profile !== state.answers.feel || !zones.includes(state.answers.zone) || !scents.includes(state.answers.scent)) return false;
          return requiredConstraint === 'none' || product.dataset[requiredConstraint] === 'true';
        };
        products.forEach(product => product.hidden = !matchProduct(product));
        const match = products.find(product => matchProduct(product) && product.dataset.available === 'true');
        if (!productByBlock(state.answers.product) || !matchProduct(productByBlock(state.answers.product))) {
          state.answers.product = match?.dataset.block || '';
        }
        if (noSafeMatch) noSafeMatch.hidden = Boolean(match);
      }
      if (flow === 'gift-finder' && state.step === 2) {
        const s = state.answers.scent;
        const r = state.answers.recipient;
        const map = {
          partner: { floral: ['rose', 'sandelholz'], herbal: ['rosmarin', 'aprikose'], citrus: ['aprikose', 'rosmarin'], lavender: ['ziegenmilch', 'rose'], warm: ['sandelholz', 'ziegenmilch'], surprise: ['sandelholz', 'rose'] },
          family: { floral: ['rose', 'ziegenmilch'], herbal: ['rosmarin', 'sandelholz'], citrus: ['aprikose', 'rose'], lavender: ['ziegenmilch', 'sandelholz'], warm: ['sandelholz', 'aprikose'], surprise: ['ziegenmilch', 'sandelholz'] },
          friend: { floral: ['rose', 'aprikose'], herbal: ['rosmarin', 'rose'], citrus: ['aprikose', 'sandelholz'], lavender: ['ziegenmilch', 'rosmarin'], warm: ['sandelholz', 'rose'], surprise: ['aprikose', 'rosmarin'] },
          team: { floral: ['rose', 'sandelholz'], herbal: ['rosmarin', 'ziegenmilch'], citrus: ['aprikose', 'rosmarin'], lavender: ['ziegenmilch', 'aprikose'], warm: ['sandelholz', 'rosmarin'], surprise: ['sandelholz', 'aprikose'] },
          self: { floral: ['rose', 'ziegenmilch'], herbal: ['rosmarin', 'aprikose'], citrus: ['aprikose', 'rosmarin'], lavender: ['ziegenmilch', 'sandelholz'], warm: ['sandelholz', 'rose'], surprise: ['ziegenmilch', 'rosmarin'] }
        };
        const mappedIds = (map[r] && map[r][s]) || [];

        let match = products.find(p => p.dataset.block === mappedIds[0] && safeProduct(p));
        let altMatch = products.find(p => p.dataset.block === mappedIds[1] && safeProduct(p));

        if (!match && altMatch) { match = altMatch; altMatch = null; }

        products.forEach(product => {
          product.hidden = product !== match && product !== altMatch;
          product.classList.toggle('is-primary-match', product === match);
          product.classList.toggle('is-secondary-match', product === altMatch);
        });

        const rationaleEl = root.querySelector('[data-rationale]') || (() => {
           const p = document.createElement('p');
           p.setAttribute('data-rationale', 'true');
           p.className = 'guided-rationale';
           p.style.fontFamily = 'var(--mono, monospace)';
           p.style.fontSize = '12px';
           p.style.marginBottom = '16px';
           p.style.color = 'var(--flow-accent, #74823e)';
           const productsContainer = root.querySelector('.guided__products');
           if (productsContainer) productsContainer.before(p);
           return p;
       })();

        if (match) {
           const loc = document.documentElement.lang || 'en';
           const rationaleText = {
              en: `Matched for ${r === 'self' ? 'yourself' : 'recipient'} based on ${s} scent profile.`,
              de: `Für ${r === 'self' ? 'dich' : 'Empfänger:in'} anhand des ${s}-Duftprofils ausgewählt.`,
              fr: `Sélectionné pour ${r === 'self' ? 'vous-même' : 'le destinataire'} (profil: ${s}).`,
              ar: `تم اختياره لـ ${r === 'self' ? 'نفسك' : 'المستلم'} بناءً على الرائحة (${s}).`
           };
           rationaleEl.textContent = rationaleText[loc] || rationaleText.en;
           rationaleEl.hidden = false;
        } else {
           rationaleEl.hidden = true;
        }

        if (!productByBlock(state.answers.product) || (productByBlock(state.answers.product) !== match && productByBlock(state.answers.product) !== altMatch)) {
          state.answers.product = match?.dataset.block || '';
        }
        if (noSafeMatch) noSafeMatch.hidden = Boolean(match) || Boolean(altMatch);

        // Dynamically fetch gift boxes
        const boxList = root.querySelector('[data-dynamic-boxes-list]');
        const boxContainer = root.querySelector('[data-dynamic-boxes]');
        if (boxContainer && boxList && !boxContainer.dataset.fetched) {
          boxContainer.dataset.fetched = 'true';
          fetch('/apps/seifeops/gift-boxes').then(res => res.json()).then(data => {
            if (data && data.boxes && Array.isArray(data.boxes)) {
              boxList.replaceChildren();
              data.boxes.forEach(box => {
                 const availableVariants = (box.variants || []).filter(v => v.availableForSale);
                 if (!availableVariants.length) return;
                 const imageUrl = box.image?.url;
                 if (!imageUrl || typeof imageUrl !== 'string' || !imageUrl.startsWith('http')) return;

                 const article = document.createElement('article');
                 article.className = 'guided-product';

                 const img = document.createElement('img');
                 img.src = imageUrl;
                 img.width = 160;
                 img.height = 160;
                 img.loading = 'lazy';
                 img.alt = '';
                 article.appendChild(img);

                 const contentDiv = document.createElement('div');
                 const h3 = document.createElement('h3');
                 h3.textContent = box.title || availableVariants[0].title;
                 contentDiv.appendChild(h3);

                 const priceStrong = document.createElement('strong');
                 let selectedVariantId = String(availableVariants[0].id).split('/').pop();
                 if (!/^\d+$/.test(selectedVariantId)) return;

                 const variantPrice = variant => String(variant.price || '');
                 if (availableVariants.length > 1) {
                    const select = document.createElement('select');
                    availableVariants.forEach(v => {
                        const numericId = String(v.id).split('/').pop();
                        if (!/^\d+$/.test(numericId)) return;
                        const opt = document.createElement('option');
                        opt.value = numericId;
                       opt.textContent = `${v.title} - ${variantPrice(v)}`;
                        select.appendChild(opt);
                    });
                    select.addEventListener('change', (e) => {
                       selectedVariantId = e.target.value;
                       const text = select.options[select.selectedIndex].text;
                       priceStrong.textContent = text.split(' - ').slice(1).join(' - ');
                    });
                    contentDiv.appendChild(select);
                    priceStrong.textContent = variantPrice(availableVariants[0]);
                 } else {
                    priceStrong.textContent = variantPrice(availableVariants[0]);
                 }
                 contentDiv.appendChild(priceStrong);
                 article.appendChild(contentDiv);

                 const btn = document.createElement('button');
                 btn.type = 'button';
                 btn.className = 'button';
                 btn.textContent = root.dataset.addLabel || 'Add';

                 btn.addEventListener('click', async (e) => {
                    if (btn.disabled || btn.dataset.adding === 'true') return;
                    btn.dataset.adding = 'true';
                    btn.disabled = true;
                    const prev = btn.textContent;
                    btn.textContent = root.dataset.adding || 'Adding...';

                    try {
                      const getCart = await fetch('/cart.js').then(r => r.json());
                      const currentQuantity = (getCart.items || [])
                        .filter(i => String(i.variant_id) === String(selectedVariantId))
                        .reduce((sum, item) => sum + Number(item.quantity || 0), 0);
                      const dynamicKey = transactionKey + '-dynamic';
                      let pending = null;
                      try { pending = JSON.parse(localStorage.getItem(dynamicKey) || 'null'); } catch {}
                      if (pending?.variantId === selectedVariantId && currentQuantity > Number(pending.baseline || 0)) {
                        localStorage.removeItem(dynamicKey);
                        window.location.assign(root.dataset.cartPage || '/cart');
                        return;
                      }
                      const baseline = pending?.variantId === selectedVariantId
                        ? Number(pending.baseline || 0)
                        : currentQuantity;
                      localStorage.setItem(dynamicKey, JSON.stringify({ variantId: selectedVariantId, baseline }));

                      if (currentQuantity <= baseline) {
                         const res = await fetch(root.dataset.cartUrl || '/cart/add.js', {
                           method: 'POST',
                           headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                           body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: 1 }] })
                         });
                         if (!res.ok) throw new Error('CART');
                      }

                      localStorage.removeItem(dynamicKey);
                      btn.textContent = root.dataset.success || 'Success';
                      window.location.assign(root.dataset.cartPage || '/cart');
                    } catch (err) {
                      localStorage.removeItem(transactionKey + '-dynamic');
                      delete btn.dataset.adding;
                      btn.textContent = root.dataset.errorCart || 'Error';
                      setTimeout(() => { btn.disabled = false; btn.textContent = prev; }, 2000);
                    }
                 });
                 article.appendChild(btn);
                 boxList.appendChild(article);
              });
              if (boxList.children.length > 0) {
                 boxContainer.hidden = false;
              }
            }
          }).catch(() => {});
        }

        root.querySelectorAll('[data-gift-finder-customizer]').forEach(link => {
          const params = new URLSearchParams();
          if (state.occasion) params.set('occasion', state.occasion);
          if (state.edition) params.set('edition', state.edition);
          if (state.answers.recipient) params.set('recipient', state.answers.recipient);
          if (state.answers.scent) params.set('scent', state.answers.scent);
          if (match) params.append('prefill', match.dataset.block);
          if (altMatch) params.append('prefill', altMatch.dataset.block);
          link.hash = params.toString();
        });
      }
      if (flow === 'gift-finder' && noSafeMatch) noSafeMatch.hidden = !finderUnavailable();
      root.querySelectorAll('[data-capacity-status]').forEach(status => {
        status.textContent = `${used()} / ${capacity()}`;
      });
      const textarea = root.querySelector('[data-message]');
      if (textarea && textarea.value !== state.message) textarea.value = state.message;
      const count = root.querySelector('[data-message-count]');
      if (count) count.textContent = state.message.length;
      const cardPreview = root.querySelector('[data-card-preview]');
      if (cardPreview) cardPreview.textContent = state.message || cardPreview.dataset.empty || '';
      const ribbons = [...root.querySelectorAll('[name="ribbon"]')];
      if (ribbons.length) {
        if (!ribbons.some(input => input.value === state.ribbon)) state.ribbon = ribbons[0].value;
        ribbons.forEach(input => input.checked = input.value === state.ribbon);
      }
      const selectedRibbon = ribbons.find(input => input.value === state.ribbon);
      const ribbonPreview = root.querySelector('[data-box-ribbon]');
      if (ribbonPreview) {
        const token = selectedRibbon?.dataset.ribbonToken || '';
        const color = selectedRibbon?.dataset.ribbonColor || '';
        ribbonPreview.dataset.ribbon = token;
        if (/^#[0-9a-f]{3,8}$/i.test(color) && ribbonPreview.style) ribbonPreview.style.backgroundColor = color;
        else ribbonPreview.style?.removeProperty('background-color');
      }
      const escapeHtml = value => String(value).replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]));
      const summaryLine = (label, value, price = '') => `<li><span><small>${escapeHtml(label)}</small><bdi>${escapeHtml(value)}</bdi></span>${price ? `<strong><bdi>${escapeHtml(price)}</bdi></strong>` : ''}</li>`;
      const lines = [];
      const answerOrder = flow === 'gift-finder' ? ['recipient', 'scent', 'product'] : flow === 'gift-box' ? ['box'] : ['feel', 'zone', 'scent', 'needs', 'product'];
      answerOrder.forEach(name => {
        const value = state.answers[name];
        if (!value) return;
        if (name === 'product' || name === 'box') {
          const p = productByBlock(value); if (p) lines.push(summaryLine(root.dataset[`property${name[0].toUpperCase()}${name.slice(1)}`] || '', p.dataset.title, p.dataset.priceLabel));
        } else lines.push(summaryLine(root.dataset[`property${name[0].toUpperCase()}${name.slice(1)}`] || '', answerLabel(name, value)));
      });
      componentProducts.filter(product => safeProduct(product) && Number(state.quantities[product.dataset.block]) > 0).forEach(product => lines.push(summaryLine(root.dataset.propertyItems || '', `${Number(state.quantities[product.dataset.block])} × ${product.dataset.title}`, money(root, Number(product.dataset.price) * Number(state.quantities[product.dataset.block])))));
      if (state.ribbon && selectedRibbon) lines.push(summaryLine(root.dataset.propertyRibbon || '', selectedRibbon.closest('label')?.querySelector('span')?.textContent.trim() || state.ribbon));
      if (state.message) lines.push(summaryLine(root.dataset.propertyMessage || '', state.message));
      summary.innerHTML = lines.length ? `<ul>${lines.join('')}</ul>` : `<p>${escapeHtml(root.dataset.summaryEmpty || '')}</p>`;
      const resultVisual = root.querySelector('[data-result-visual]');
      if (resultVisual) {
        const selectedProduct = productByBlock(state.answers.product);
        const resultMedia = root.querySelector('[data-result-media]');
        const resultTitle = root.querySelector('[data-result-title]');
        const resultEdition = root.querySelector('[data-result-edition]');
        const resultSize = root.querySelector('[data-result-size]');
        resultVisual.hidden = !selectedProduct;
        if (selectedProduct) {
          if (resultTitle) resultTitle.textContent = selectedProduct.dataset.title;
          if (resultEdition) resultEdition.textContent = answerLabel('editionChoice', state.answers.editionChoice);
          if (resultSize) resultSize.textContent = selectedProduct.dataset.variantTitle || '';
          if (resultMedia) {
            const image = selectedProduct.querySelector('img');
            resultMedia.replaceChildren();
            if (image) {
              const clone = image.cloneNode(true);
              clone.removeAttribute('id');
              resultMedia.append(clone);
            }
          }
        }
      }
      let total = 0;
      if (flow === 'gift-box') {
        const selectedBox = productByBlock(state.answers.box);
        total += Number(selectedBox?.dataset.price || 0);
        componentProducts.forEach(product => {
          total += Number(product.dataset.price || 0) * Number(state.quantities[product.dataset.block] || 0);
        });
      } else {
        total = Number(productByBlock(state.answers.product)?.dataset.price || 0);
      }
      root.querySelectorAll('[data-live-total]').forEach(output => {
        output.textContent = total ? money(root, total) : '';
      });
      const slots = root.querySelector('[data-box-slots]');
      if (slots && typeof document.createElement === 'function') {
        const selectedProducts = [];
        componentProducts.forEach(product => {
          for (let index = 0; index < Number(state.quantities[product.dataset.block] || 0); index += 1) selectedProducts.push(product);
        });
        slots.replaceChildren();
        for (let index = 0; index < capacity(); index += 1) {
          const slot = document.createElement('span');
          const product = selectedProducts[index];
          slot.className = `gift-box-live__slot${product ? ' is-filled' : ''}`;
          if (product) {
            slot.title = product.dataset.title;
            const image = product.querySelector('img');
            if (image) {
              const clone = image.cloneNode(true);
              clone.removeAttribute('id');
              clone.setAttribute('aria-hidden', 'true');
              clone.alt = '';
              slot.append(clone);
            } else slot.textContent = '●';
          } else slot.textContent = '+';
          slots.append(slot);
        }
      }
      const review = root.querySelector('[data-review]');
      if (review) {
        const edit = step => `<button type="button" class="guided__review-edit" data-review-edit="${step}">${escapeHtml(root.dataset.editLabel || '')}</button>`;
        review.innerHTML = lines.length ? `<ul>${lines.join('')}</ul><div class="guided__review-actions">${edit(0)}${edit(1)}${edit(2)}</div>` : `<p>${escapeHtml(root.dataset.summaryEmpty || '')}</p>`;
      }
      const final = state.step === panels.length - 1;
      next.hidden = final;
      add.hidden = !final || giftBoxBlocked;
      next.disabled = giftBoxBlocked;
      next.setAttribute('aria-disabled', String(!valid()));
      add.disabled = !valid() || Boolean(pendingTransaction);
      const reviewCart = root.querySelector('[data-review-cart]');
      if (reviewCart) reviewCart.hidden = !pendingTransaction;
      const recheckCart = root.querySelector('[data-recheck-cart]');
      if (recheckCart) recheckCart.hidden = !pendingTransaction;
      back.hidden = state.step === 0;
      error.hidden = true;
      if (pendingTransaction) {
        error.textContent = unresolvedMessage();
        error.hidden = false;
      }
      if (announcement) {
        announcement.textContent = formatPanelAnnouncement();
      }
      const contextEl = root.querySelector('[data-guided-context]');
      if (contextEl) {
        const contextValues = [
          state.occasion && root.dataset[`contextOccasion${state.occasion.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase()).replace(/^./, letter => letter.toUpperCase())}`],
          state.edition && root.dataset.contextEditionSeasonal,
          state.sourceRecipient && root.dataset[`contextRecipient${state.sourceRecipient.replace(/^./, letter => letter.toUpperCase())}`],
          state.sourcePicker && root.dataset[`contextPicker${state.sourcePicker.replace(/^./, letter => letter.toUpperCase())}`],
          state.sourceScent && root.dataset[`contextScent${state.sourceScent.replace(/^./, letter => letter.toUpperCase())}`],
          state.sourceGiftTheme && (state.sourceGiftThemeLabel || state.sourceGiftTheme)
        ].filter(Boolean);
        contextEl.textContent = contextValues.join(' · ');
        contextEl.hidden = contextValues.length === 0;
      }
      persist();
    };

    root.querySelector('[data-guided-start]')?.addEventListener('click', () => {
      root.classList.add('is-started');
      workspace.hidden = false;
      workspace.scrollIntoView({ behavior: 'smooth', block: 'start' });
      render();
      if (stale && announcement) {
        announcement.textContent = root.dataset.stale || root.dataset.errorInventory;
        stale = false;
      } else if (recovered && announcement) {
        announcement.textContent = `${root.dataset.recovered} ${formatPanelAnnouncement()}`.trim();
        recovered = false;
      }
      if (finderUnavailable()) noSafeMatch?.focus();
      else panels[state.step]?.querySelector('h2')?.focus();
    });
    root.querySelector('[data-review]')?.addEventListener('click', event => {
      const edit = event.target.closest('[data-review-edit]');
      if (!edit) return;
      state.step = Math.max(0, Math.min(panels.length - 1, Number(edit.dataset.reviewEdit)));
      render();
      panels[state.step]?.querySelector('h2')?.focus();
    });
    root.querySelectorAll('[data-answer]').forEach(button => button.addEventListener('click', () => {
      if (state.answers[button.dataset.answer] !== button.dataset.value) invalidateRequest();
      state.answers[button.dataset.answer] = button.dataset.value;
      render();
    }));
    root.querySelectorAll('[role="radiogroup"]').forEach(group => group.addEventListener('keydown', event => {
      const radios = [...group.querySelectorAll('[role="radio"]:not([disabled])')];
      const current = event.target.closest('[role="radio"]');
      if (!current || !radios.includes(current)) return;
      let index = radios.indexOf(current);
      const rtl = root.dir === 'rtl';
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = radios.length - 1;
      else if (event.key === 'ArrowDown' || event.key === 'ArrowRight') index = (index + (event.key === 'ArrowRight' && rtl ? -1 : 1) + radios.length) % radios.length;
      else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') index = (index + (event.key === 'ArrowLeft' && rtl ? 1 : -1) + radios.length) % radios.length;
      else return;
      event.preventDefault();
      const chosen = radios[index];
      if (chosen.dataset.answer) {
        if (state.answers[chosen.dataset.answer] !== chosen.dataset.value) invalidateRequest();
        state.answers[chosen.dataset.answer] = chosen.dataset.value;
      }
      else {
        const product = chosen.closest('[data-product]');
        if (!safeProduct(product) || !product.dataset.answerName) return;
        if (state.answers[product.dataset.answerName] !== product.dataset.block) invalidateRequest();
        state.answers[product.dataset.answerName] = product.dataset.block;
      }
      render();
      chosen.focus();
    }));
    products.forEach(product => product.querySelector('[data-select-product]')?.addEventListener('click', () => {
      if (!safeProduct(product) || !product.dataset.answerName) return;
      if (state.answers[product.dataset.answerName] !== product.dataset.block) invalidateRequest();
      state.answers[product.dataset.answerName] = product.dataset.block;
      if (product.dataset.answerName === 'box') {
        clampQuantitiesToCapacity();
      }
      render();
    }));
    products.forEach(product => product.querySelector('[data-variant-select]')?.addEventListener('change', event => {
      const option = event.target.selectedOptions[0];
      if (!option || option.dataset.available !== 'true' || !allowedIds(product).has(option.value)) {
        invalidateRequest();
        delete state.answers[product.dataset.answerName];
        delete state.quantities[product.dataset.block];
        delete state.variants[product.dataset.block];
        product.dataset.available = 'false';
        render();
        return;
      }
      if (String(product.dataset.variant) !== option.value) invalidateRequest();
      product.dataset.variant = option.value;
      product.dataset.variantTitle = option.dataset.title || '';
      product.dataset.price = option.dataset.price;
      product.dataset.priceLabel = option.dataset.priceLabel;
      product.dataset.available = option.dataset.available;
      state.variants[product.dataset.block] = option.value;
      product.querySelector('[data-variant-input]').value = option.value;
      product.querySelector('[data-product-price]').textContent = option.dataset.priceLabel;
      render();
    }));
    products.forEach(product => {
      product.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
        if (!safeProduct(product) || used() >= capacity() || Number(state.quantities[product.dataset.block] || 0) >= Number(product.dataset.max || 2)) return;
        invalidateRequest();
        state.quantities[product.dataset.block] = Number(state.quantities[product.dataset.block] || 0) + 1; render();
      });
      product.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
        if (Number(state.quantities[product.dataset.block] || 0) <= 0) return;
        invalidateRequest();
        state.quantities[product.dataset.block] = Math.max(0, Number(state.quantities[product.dataset.block] || 0) - 1); render();
      });
    });
    root.querySelectorAll('[data-catalog-tab]').forEach(tab => tab.addEventListener('click', () => {
      state.category = tab.dataset.catalogTab;
      render();
    }));
    let searchTimeout;
    root.querySelectorAll('[data-catalog-search]').forEach(input => input.addEventListener('input', (e) => {
      state.searchQuery = e.target.value.toLowerCase().trim();
      render();
      clearTimeout(searchTimeout);
      if (state.searchQuery.length >= 2) {
         searchTimeout = setTimeout(() => {
            fetch(`/apps/seifeops/gift-box-components?q=${encodeURIComponent(state.searchQuery)}`)
              .then(res => res.json())
              .then(data => {
                  if (data && data.products && Array.isArray(data.products)) {
                     const catalog = root.querySelector('[data-component-catalog]');
                     if (!catalog) return;
                     data.products.forEach(comp => {
                         if (!comp.id || !comp.title || !comp.variants) return;
                         const validVariants = comp.variants.filter(v => v.availableForSale && /^\d+$/.test(String(v.id).split('/').pop()));
                         if (!validVariants.length) return;

                         const safeId = String(comp.id).split('/').pop();
                         const blockId = 'comp-' + safeId;
                         if (root.querySelector(`[data-block="${blockId}"]`)) return;

                         const article = document.createElement('div');
                         article.className = 'guided-product';
                         article.dataset.product = '';
                         article.dataset.block = blockId;
                         article.dataset.productId = comp.id;
                         if (comp.handle) article.dataset.productHandle = comp.handle;
                         article.dataset.title = comp.title;
                         article.dataset.variant = String(validVariants[0].id).split('/').pop();
                         const priceCents = Math.round(Number(validVariants[0].price) * 100);
                         if (!Number.isSafeInteger(priceCents) || priceCents < 0) return;
                         article.dataset.price = String(priceCents);
                         article.dataset.priceLabel = (root.dataset.moneyFormat || '{{amount}}').replace('{{amount}}', (priceCents / 100).toFixed(2));
                         article.dataset.available = 'true';
                         article.dataset.allowedVariants = ',' + article.dataset.variant + ',';
                         article.dataset.category = 'seifen'; // default
                         article.dataset.max = '2'; // default

                         const btn = document.createElement('button');
                         btn.type = 'button';
                         btn.dataset.selectProduct = '';
                         btn.setAttribute('aria-pressed', 'false');

                         const span = document.createElement('span');
                         const strong = document.createElement('strong');
                         const bdiTitle = document.createElement('bdi');
                         bdiTitle.textContent = comp.title;
                         strong.appendChild(bdiTitle);

                         const em = document.createElement('em');
                         em.dataset.productPrice = '';
                         const bdiPrice = document.createElement('bdi');
                         bdiPrice.textContent = article.dataset.priceLabel;
                         em.appendChild(bdiPrice);

                         span.appendChild(strong);
                         span.appendChild(em);

                         if (comp.image && comp.image.url && comp.image.url.startsWith('http')) {
                            const img = document.createElement('img');
                            img.src = comp.image.url;
                            img.loading = 'lazy';
                            img.alt = comp.title;
                            btn.appendChild(img);
                         } else {
                            const placeholder = document.createElement('span');
                            placeholder.className = 'guided-product__placeholder';
                            placeholder.setAttribute('aria-hidden', 'true');
                            btn.appendChild(placeholder);
                         }

                         btn.appendChild(span);
                         btn.addEventListener('click', () => {
                            if (btn.disabled) return;
                            const currentQty = Number(state.quantities[blockId] || 0);
                            if (currentQty === 0 && capacity() > 0 && used() >= capacity()) return;
                            if (currentQty === 0) {
                               state.quantities[blockId] = 1;
                            } else {
                               delete state.quantities[blockId];
                            }
                            render();
                         });
                         article.appendChild(btn);

                         const form = document.createElement('form');
                         form.dataset.productForm = '';
                         const input = document.createElement('input');
                         input.type = 'hidden';
                         input.name = 'id';
                         input.dataset.variantInput = '';
                         input.value = article.dataset.variant;
                         form.appendChild(input);
                         article.appendChild(form);

                         const qtyDiv = document.createElement('div');
                         qtyDiv.className = 'guided-product__qty';

                         const minus = document.createElement('button');
                         minus.type = 'button';
                         minus.dataset.qtyMinus = '';
                         minus.textContent = '−';
                         minus.addEventListener('click', () => {
                            const currentQty = Number(state.quantities[blockId] || 0);
                            if (currentQty > 0) {
                               state.quantities[blockId] = currentQty - 1;
                               if (state.quantities[blockId] === 0) delete state.quantities[blockId];
                               render();
                            }
                         });

                         const output = document.createElement('output');
                         output.dataset.qty = '';
                         output.textContent = '0';

                         const plus = document.createElement('button');
                         plus.type = 'button';
                         plus.dataset.qtyPlus = '';
                         plus.textContent = '+';
                         plus.addEventListener('click', () => {
                            const currentQty = Number(state.quantities[blockId] || 0);
                            if (currentQty < Number(article.dataset.max) && (capacity() === 0 || used() < capacity())) {
                               state.quantities[blockId] = currentQty + 1;
                               render();
                            }
                         });

                         qtyDiv.appendChild(minus);
                         qtyDiv.appendChild(output);
                         qtyDiv.appendChild(plus);
                         article.appendChild(qtyDiv);

                         catalog.appendChild(article);
                         products.push(article);
                         componentProducts.push(article);
                     });
                     render();
                  }
              })
              .catch(() => {});
         }, 300);
      }
    }));
    root.querySelector('[role="tablist"]')?.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const tabs = [...root.querySelectorAll('[data-catalog-tab]')];
      let index = tabs.indexOf(event.target);
      if (index < 0) return;
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = tabs.length - 1;
      else index = (index + (event.key === 'ArrowRight' ? (root.dir === 'rtl' ? -1 : 1) : (root.dir === 'rtl' ? 1 : -1)) + tabs.length) % tabs.length;
      event.preventDefault();
      tabs[index].click();
      tabs[index].focus();
    });
    root.querySelector('[data-message]')?.addEventListener('input', e => {
      const message = e.target.value.slice(0, 140);
      if (state.message !== message) invalidateRequest();
      state.message = message;
      render();
    });
    root.querySelectorAll('[name="ribbon"]').forEach(input => input.addEventListener('change', () => {
      if (state.ribbon !== input.value) invalidateRequest();
      state.ribbon = input.value;
      render();
    }));
    next.addEventListener('click', () => {
      if (finderUnavailable()) {
        state.step = panels.length - 1;
        render();
        noSafeMatch?.focus();
        return;
      }
      if (!valid()) {
        error.textContent = flow === 'gift-box'
          ? state.step === 0 ? root.dataset.errorBox : state.step === 1 ? root.dataset.errorCapacity : state.step === 2 ? root.dataset.errorRibbon : root.dataset.errorRequired
          : root.dataset.errorRequired;
        error.hidden = false;
        error.focus();
        return;
      }
      state.step = Math.min(panels.length - 1, state.step + 1);
      render();
      panels[state.step].querySelector('h2')?.focus();
    });
    back.addEventListener('click', () => {
      state.step = Math.max(0, state.step - 1);
      render();
      panels[state.step]?.querySelector('h2')?.focus();
    });
    const restart = () => {
      state.step = 0;
      state.answers = {};
      state.quantities = {};
      state.variants = {};
      state.message = '';
      state.ribbon = '';
      state.category = 'seifen';
      state.occasion = '';
      state.edition = '';
      state.sourceRecipient = '';
      state.sourcePicker = '';
      state.sourceScent = '';
      state.sourceGiftTheme = '';
      state.sourceGiftThemeLabel = '';
      state.occasion = hashContext.occasion;
      state.edition = hashContext.edition;
      state.sourceRecipient = hashContext.sourceRecipient;
      state.sourcePicker = hashContext.sourcePicker;
      state.sourceScent = hashContext.sourceScent;
      state.requestMarker = '';
      state.requestSignature = '';
      state.requestAttempted = false;
      state.requestBlocked = false;
      try { localStorage.removeItem(root.dataset.storageKey); } catch (_) {}
      render();
      if (finderUnavailable()) noSafeMatch?.focus();
      else panels[0]?.querySelector('h2')?.focus();
    };
    root.querySelector('[data-guided-restart]')?.addEventListener('click', restart);
    root.addEventListener('guided:restart', restart);
    let submitting = false;
    const showError = message => {
      error.textContent = message;
      error.hidden = false;
      error.focus();
    };
    const unresolvedMessage = () => {
      const locale = (document.documentElement.lang || 'de').split('-')[0];
      return ({
        fr: 'Une demande d’ajout reste non résolue. Aucun nouvel envoi ne sera effectué. Vérifiez le panier.',
        en: 'A basket add request remains unresolved. No new request will be sent. Review the basket.',
        ar: 'لا يزال طلب الإضافة إلى السلة غير محسوم. لن يُرسل طلب جديد. راجع السلة.',
        de: 'Eine Warenkorb-Anfrage ist noch ungeklärt. Es wird keine neue Anfrage gesendet. Prüfe den Warenkorb.'
      })[locale] || root.dataset.errorReview;
    };
    const newRequestMarker = () => window.crypto?.randomUUID?.() || `guided-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
    const reconcileCart = async (marker, expectedItems, signal) => {
      const fallbackController = signal ? null : new AbortController();
      const fallbackTimeout = fallbackController ? window.setTimeout(() => fallbackController.abort(), 8000) : null;
      try {
        const response = await fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' }, signal: signal || fallbackController.signal });
        if (!response.ok) return 'unavailable';
        const cart = await response.json();
        const marked = (Array.isArray(cart?.items) ? cart.items : []).filter(line => line?.properties?.['_Guided request'] === marker);
        if (!marked.length) return 'none';
        const expected = new Map();
        expectedItems.forEach(item => expected.set(String(item.id), (expected.get(String(item.id)) || 0) + Number(item.quantity)));
        const actual = new Map();
        marked.forEach(line => {
          const id = String(line.variant_id || line.id || '');
          actual.set(id, (actual.get(id) || 0) + Number(line.quantity || 0));
        });
        const complete = actual.size === expected.size && [...expected].every(([id, quantity]) => actual.get(id) === quantity);
        return complete ? 'complete' : 'partial';
      } catch (_) {
        return 'unavailable';
      } finally {
        if (fallbackTimeout) window.clearTimeout(fallbackTimeout);
      }
    };
    const storePendingTransaction = transaction => {
      try {
        localStorage.setItem(transactionKey, JSON.stringify(transaction));
        pendingTransaction = transaction;
        return true;
      } catch (_) {
        return false;
      }
    };
    const clearPendingTransaction = () => {
      pendingTransaction = null;
      try {
        localStorage.removeItem(transactionKey);
      } catch (_) {
        try { localStorage.setItem(transactionKey, JSON.stringify({ version: 1, flow, status: 'resolved' })); } catch (_) {}
      }
    };
    const blockRetry = message => {
      add.disabled = true;
      const reviewCart = root.querySelector('[data-review-cart]');
      if (reviewCart) reviewCart.hidden = false;
      const recheckCart = root.querySelector('[data-recheck-cart]');
      if (recheckCart) recheckCart.hidden = false;
      showError(message || unresolvedMessage());
    };
    const recheckCart = root.querySelector('[data-recheck-cart]');
    recheckCart?.addEventListener('click', async () => {
      if (!pendingTransaction || submitting) return;
      submitting = true;
      root.setAttribute('aria-busy', 'true');
      recheckCart.disabled = true;
      const label = recheckCart.textContent;
      if (announcement) announcement.textContent = label;
      const result = await reconcileCart(pendingTransaction.marker, pendingTransaction.items, undefined);
      submitting = false;
      root.setAttribute('aria-busy', 'false');
      if (result === 'complete') {
        clearPendingTransaction();
        add.textContent = root.dataset.success;
        if (announcement) announcement.textContent = root.dataset.success;
        try { localStorage.removeItem(root.dataset.storageKey); } catch (_) {}
        window.location.assign(root.dataset.cartPage);
        return;
      }
      recheckCart.disabled = false;
      blockRetry();
      if (announcement) announcement.textContent = unresolvedMessage();
      recheckCart.focus();
    });
    const verifyCurrentProducts = async (selectedProducts, signal) => {
      const changed = [];
      await Promise.all(selectedProducts.map(async product => {
        const handle = String(product?.dataset.productHandle || '');
        const id = String(product?.dataset.variant || '');
        if (!safeProduct(product) || !handle || !allowedIds(product).has(id)) {
          changed.push(product);
          return;
        }
        const response = await fetch(`${shopRoot}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' }, signal });
        if (!response.ok) throw new Error('PROVIDER');
        const current = (await response.json())?.variants?.find(variant => String(variant.id) === id);
        if (!current || current.available !== true || Number(current.price) !== Number(product.dataset.price)) {
          if (current) {
            product.dataset.price = String(current.price);
            product.dataset.priceLabel = money(root, Number(current.price));
            product.dataset.available = String(current.available === true);
            product.dataset.variantTitle = typeof current.title === 'string' ? current.title : product.dataset.variantTitle;
            const select = product.querySelector('[data-variant-select]');
            const option = select ? [...select.options].find(candidate => candidate.value === id) : null;
            if (option) {
              option.dataset.price = String(current.price);
              option.dataset.priceLabel = product.dataset.priceLabel;
              option.dataset.available = String(current.available === true);
              if (typeof current.title === 'string') {
                option.dataset.title = current.title;
                option.textContent = current.title;
              }
            }
            const price = product.querySelector('[data-product-price]');
            if (price) price.textContent = product.dataset.priceLabel;
          }
          changed.push(product);
        }
      }));
      if (!changed.length) return true;
      changed.forEach(product => {
        delete state.quantities[product.dataset.block];
        delete state.variants[product.dataset.block];
        if (state.answers.product === product.dataset.block) delete state.answers.product;
        if (state.answers.box === product.dataset.block) delete state.answers.box;
      });
      state.step = flow === 'gift-box' && changed.some(product => product.dataset.answerName === 'box') ? 0 : flow === 'gift-box' ? 1 : panels.length - 1;
      state.requestMarker = '';
      state.requestSignature = '';
      state.requestAttempted = false;
      state.requestBlocked = false;
      stale = true;
      render();
      showError(root.dataset.errorInventory);
      return false;
    };
    add.addEventListener('click', async () => {
      if (submitting) {
        showError(root.dataset.errorDuplicate);
        return;
      }
      if (pendingTransaction) {
        blockRetry();
        return;
      }
      if (!valid()) {
        if (finderUnavailable()) {
          noSafeMatch?.focus();
          return;
        }
        showError(flow === 'gift-box'
          ? !state.answers.box ? root.dataset.errorBox : used() !== capacity() ? root.dataset.errorCapacity : !ribbonValid() ? root.dataset.errorRibbon : root.dataset.errorRequired
          : root.dataset.errorRequired);
        return;
      }
      const props = { [`_${root.dataset.propertyJourney}`]: root.dataset.propertyJourneyValue };
      Object.entries(state.answers).forEach(([name, value]) => {
        if (!['product', 'box'].includes(name)) {
          const propertyName = root.dataset[`property${name[0].toUpperCase()}${name.slice(1)}`];
          if (propertyName) props[propertyName] = answerLabel(name, value);
        }
      });
      if (state.message) props[root.dataset.propertyMessage] = state.message;
      if (state.ribbon) {
        const ribbon = [...root.querySelectorAll('[name="ribbon"]')].find(input => input.value === state.ribbon);
        props[root.dataset.propertyRibbon] = ribbon?.closest('label')?.querySelector('span')?.textContent.trim() || state.ribbon;
      }
      if (state.occasion) props['Occasion'] = state.occasion;
      if (state.edition) props['Edition context'] = state.edition;
      if (state.sourceRecipient && root.dataset.propertyRecipient) props[root.dataset.propertyRecipient] = root.dataset[`contextRecipient${state.sourceRecipient.replace(/^./, letter => letter.toUpperCase())}`];
      if (state.sourcePicker && root.dataset.propertyPicker) props[root.dataset.propertyPicker] = root.dataset[`contextPicker${state.sourcePicker.replace(/^./, letter => letter.toUpperCase())}`];
      if (state.sourceScent && root.dataset.propertyScent) props[root.dataset.propertyScent] = root.dataset[`contextScent${state.sourceScent.replace(/^./, letter => letter.toUpperCase())}`];
      if (flow === 'gift-box' && state.sourceGiftTheme) {
        props['_Gift finder theme'] = state.sourceGiftTheme;
        if (root.dataset.propertyScent) props[root.dataset.propertyScent] = state.sourceGiftThemeLabel || state.sourceGiftTheme;
      }
      const items = [];
      if (flow === 'gift-box') {
        const box = productByBlock(state.answers.box);
        if (box) items.push({ id: Number(box.dataset.variant), quantity: 1, properties: props });
        componentProducts.forEach(product => {
          const quantity = Number(state.quantities[product.dataset.block] || 0);
          if (quantity && safeProduct(product)) items.push({ id: Number(product.dataset.variant), quantity, properties: props });
        });
      } else {
        const product = productByBlock(state.answers.product);
        if (product) items.push({ id: Number(product.dataset.variant), quantity: 1, properties: props });
      }
      if (!items.length) { error.textContent = root.dataset.errorRequired; error.hidden = false; return; }

      if (flow === 'gift-finder') {
        if (!state.answers.recipient || !state.answers.scent || !state.answers.product) {
          error.textContent = root.dataset.errorRequired; error.hidden = false; return;
        }
      } else if (flow === 'gift-box') {
        const componentCount = items.slice(1).reduce((sum, item) => sum + Number(item.quantity), 0);
        if (!state.answers.box || items[0]?.quantity !== 1 || componentCount !== capacity() || used() !== capacity() || !ribbonValid()) {
          error.textContent = root.dataset.errorRequired; error.hidden = false; return;
        }
      }

      submitting = true;
      root.setAttribute('aria-busy', 'true');
      add.disabled = true; add.textContent = root.dataset.adding;
      if (announcement) announcement.textContent = root.dataset.adding;
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 12000);
      let confirmed = false;
      try {
        const selectedProducts = flow === 'gift-box'
          ? [productByBlock(state.answers.box), ...componentProducts.filter(product => Number(state.quantities[product.dataset.block]) > 0)]
          : [productByBlock(state.answers.product)];
        if (!await verifyCurrentProducts(selectedProducts, controller.signal)) return;
        const signature = JSON.stringify(items.map(item => ({ id: item.id, quantity: item.quantity, properties: item.properties })));
        if (!state.requestMarker || state.requestSignature !== signature) {
          state.requestMarker = newRequestMarker();
          state.requestSignature = signature;
        }
        items.forEach(item => { item.properties = { ...item.properties, '_Guided request': state.requestMarker }; });
        persist();
        const transaction = { version: 1, flow, marker: state.requestMarker, items, createdAt: Date.now() };
        if (!storePendingTransaction(transaction)) {
          add.disabled = false;
          add.textContent = root.dataset.addLabel;
          showError(root.dataset.errorProvider);
          return;
        }
        let response;
        try {
          response = await fetch(root.dataset.cartUrl, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items }), signal: controller.signal });
        } catch (requestError) {
          requestError.ambiguous = true;
          throw requestError;
        }
        if (!response.ok) {
          const requestError = new Error();
          requestError.inventory = response.status === 422;
          requestError.dispatched = true;
          throw requestError;
        }
        clearPendingTransaction();
        confirmed = true;
      } catch (requestError) {
        if (pendingTransaction && (requestError.dispatched || requestError.ambiguous || requestError.name === 'AbortError')) {
          const reconciliation = await reconcileCart(pendingTransaction.marker, pendingTransaction.items, undefined);
          if (reconciliation === 'complete') confirmed = true;
          if (confirmed) clearPendingTransaction();
          else {
            blockRetry();
            return;
          }
        }
        if (!confirmed) {
          const message = !navigator.onLine
            ? root.dataset.errorOffline
            : requestError.name === 'AbortError' ? root.dataset.errorTimeout
            : requestError.inventory ? root.dataset.errorInventory : root.dataset.errorProvider;
          add.disabled = false;
          add.textContent = root.dataset.addLabel;
          showError(message);
        }
      } finally {
        window.clearTimeout(timeout);
        submitting = false;
        root.setAttribute('aria-busy', 'false');
      }
      if (!confirmed) return;
      add.textContent = root.dataset.success;
      if (announcement) announcement.textContent = root.dataset.success;
      try { localStorage.removeItem(root.dataset.storageKey); } catch (_) {}
      window.location.assign(root.dataset.cartPage);
    });
    if (state.step > panels.length - 1) state.step = 0;
    root.addEventListener('guided:exit', () => root.classList.remove('is-started'));
    render();
    if (invalidFinderPrefill && error) {
      error.textContent = root.dataset.errorInventory || root.dataset.errorRequired;
      error.hidden = false;
    }
  });
})();